import { Component, Input, OnInit } from '@angular/core';

import { Task } from './monday-tasks/task';
import { MondayTasksService } from './monday-tasks/monday-tasks.service';

@Component({
  selector: 'app-monday-tasks',
  templateUrl: './monday-tasks.component.html',
  styleUrls: ['./monday-tasks.component.css']
})
export class MondayTasksComponent implements OnInit {

  @Input() onShowPeriod;

  addMondayTask: Boolean = false;

  newTask: Task = {
    title: '',
    category: 'incremental',
    description: '',
    member: ['']
  };
  
  mockTasks: Task [] = [];

  constructor(
    private _mondayTasksService: MondayTasksService) {}

  getMockTasks(): void {
    this._mondayTasksService.getMockTasks().then(mockTasks => this.mockTasks = mockTasks);
  }

  ngOnInit(): void {
    this.getMockTasks();
  }

  createMondayTask($event: any) {
    this.mockTasks.push(this.newTask);
    this.newTask = {
      title: '',
      category: 'incremental',
      description: '',
      member: ['']
    };
    this.addMondayTask = false;
  }

  deleteMondayTask(data: Task) {
    const index: number = this.mockTasks.indexOf(data);
    if (index !== -1) {
        this.mockTasks.splice(index, 1);
    }
  }

  addMember(data, event) {
    if (event.keyCode === 13) {
      data.member.push(data.newMember);
      data.showAddMember = false;
      data.newMember = '';
    }
  }

  editDescription(data, event) {
    if (event.keyCode === 13) {
      data.showEditDescription = false;
    }
  }
  
}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/kanban/components/monday-tasks/monday-tasks.component.ts